import React from "react";

export function ServiceProcess() {
  const steps = [
    {
      number: "01",
      title: "Assessment & Planning",
      description: "We analyze your current systems and business needs to create a tailored AI integration strategy.",
    },
    {
      number: "02",
      title: "Architecture Design",
      description: "Design a scalable architecture using .NET , Semantic Kernel, and other Microsoft technologies.",
    },
    {
      number: "03",
      title: "Implementation",
      description: "Build your AI solution with clean code, proper testing, and comprehensive documentation.",
    },
    {
      number: "04",
      title: "Training & Handoff",
      description: "Train your team and provide all necessary tools and documentation for long-term success.",
    },
  ];

  return (
    <>
      <div id="implementation-process" className="relative scroll-mt-24">
        <section className="relative bg-gray-900 py-24">
          {/* Decorative elements */}
          <div className="absolute left-0 top-0 h-1/2 w-full bg-gradient-to-b from-gray-800 to-transparent" />
          <div className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80" aria-hidden="true">
            <div className="relative left-[calc(50%-20rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-primary to-purple-500 opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]" />
          </div>

          <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
              <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
                Our Implementation Process
              </h2>
              <p className="mt-4 text-lg text-gray-300">
                A structured approach to implementing AI solutions in your organization
              </p>
            </div>

            <div className="mx-auto mt-16 max-w-5xl">
              <div className="grid grid-cols-1 gap-8 lg:grid-cols-4">
                {steps.map((step, stepIdx) => (
                  <div
                    key={step.number}
                    className="relative flex flex-col items-start"
                  >
                    {stepIdx !== steps.length - 1 && (
                      <div
                        className="absolute left-12 top-16 hidden h-0.5 w-full bg-gradient-to-r from-primary/30 via-primary/50 to-transparent lg:block"
                        aria-hidden="true"
                      />
                    )}
                    <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary/5 ring-1 ring-primary/10">
                      <span className="text-xl font-semibold text-primary">
                        {step.number}
                      </span>
                    </div>
                    <h3 className="mt-6 text-xl font-semibold text-white">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-base text-gray-300">
                      {step.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
